import React from "react"
import * as styles from "./showcaseNotice.module.scss"

// small fixed hint that this is an archived portfolio version of the shop
export default function ShowcaseNotice() {
  return (
    <a href="/showcase/" className={styles.notice}>
      <span className={styles.dot} />
      Portfolio-Projekt<span className={styles.long}> · Shop geschlossen</span>
    </a>
  )
}
